import React, { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../Pages/Dashboard/Dashboard";
import ContactUs from "../Pages/ContactUs/ContactUs";
import Faq from "../Pages/Faq/Faq";
import BlogsDashboard from "../Pages/Blog/BlogsDashboard/BlogsDashboard";
import BlogPage from "../Pages/Blog/BlogPage/BlogPage";
import AddBlogPost from "../Pages/Blog/AddBlogPost/AddBlogPost";
import EditBlogPost from "../Pages/Blog/EditBlogPost/EditBlogPost";
import Login from "../Pages/Login/Login";
import { jwtDecode } from "jwt-decode";
import { CircularProgress } from "@mui/material";
import AssetsList from "../Pages/AssetsList/AssetsList";
import ManagerAssets from "../Pages/ManagerAssets/ManagerAssets";

const AppRoutes = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("tokenLogin");
      if (token) {
        const decode = jwtDecode(token);
        if (decode.exp * 1000 < Date.now()) {
          setIsAuthenticated(false);
          localStorage.removeItem("tokenLogin");
          setLoading(false);
        } else {
          setIsAuthenticated(true);
          setLoading(false);
        }
      } else {
        setIsAuthenticated(false);
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  const RequireAuth = ({ children, redirectTo }) => {
    if (loading) {
      return <CircularProgress />;
    } else {
      return isAuthenticated ? children : <Navigate to={redirectTo} />;
    }
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route
          path="/overview/:filed_central_index_key"
          element={<ManagerAssets />}
        />
        <Route
          path="/overview/:filed_central_index_key/:accession_number"
          element={<AssetsList />}
        />
        {/* <Route
          path="/overview/:cik/:accession_number"
          element={<AssetsFullList />}
        /> */}
        {/* <Route path="/topmanagers" element={<TopManagers />} />
        <Route
          path="/topmanagers/overview/:cik"
          element={<TopManagersFeed />}
        /> */}
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/faq" element={<Faq />} />
        <Route
          path="/blog"
          element={<BlogsDashboard isAuthenticated={isAuthenticated} />}
        />
        <Route path="/blog/:id" element={<BlogPage />} />
        <Route
          path="/blog/add"
          element={
            <RequireAuth redirectTo={"/login"}>
              <AddBlogPost />
            </RequireAuth>
          }
        />
        <Route
          path="/blog/edit/:id"
          element={
            <RequireAuth redirectTo={"/login"}>
              <EditBlogPost />
            </RequireAuth>
          }
        />
        <Route
          path="/login"
          element={
            <Login
              setIsAuthenticated={setIsAuthenticated}
              setLoading={setLoading}
              isAuthenticated={isAuthenticated}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
